"use client";

import React, { Suspense, useEffect, useState } from "react";
import { API } from "../../services/api.service";
import classNames from "classnames";
import { colVariant } from "./productFeedVariant.css";
import { useParams } from "next/navigation";
import { getDefaultLocale } from "@/config/app.config";
import dynamic from 'next/dynamic';

const Spinner = dynamic(()=> import("../Spinner"), { ssr: false });

const ProductCard = dynamic(()=> import('@/components/ProductCard'), { ssr: false });
const CarouselWrapper = dynamic(()=> import('@/blocks/Sliders/CarouselWrapper'), { ssr: false });

interface productFeedProps {
  id?: string;
  rating_value: number;
  breathtakingitem: boolean;
  isNew: boolean;
  isTopSeller: boolean;
  isLastChance: boolean;
  newLowerPrice: boolean;
  isLimitEdition: boolean;
  timeRestrictedOffer: boolean;
  numberOfItem: number;
  businessUnitCode: string;
  primaryLang: string;
  no_of_columns: number;
  displayView?: string;
  carouselAutoplay?: boolean;
  carouseltransition?: string;
  slidesToShow?: number;
  slidesToScroll?: number;
  autoplaySpeed?: number; 
  speed?: number;
  centerMode?:boolean; 
  showButtons?: boolean; 
  showPaging?: boolean; 
  infinite?:boolean; 
  pauseOnHover?:boolean; 
  swipeToSlide?: boolean; 
  draggable?: boolean; 
  variableWidth?: boolean;
  maxCardWidth?: number;
  enablePaxItems?: boolean;
  marketLocale?: string;
  btnLabel?: string;
}

const ProductFeed = ({ id, ...props }: productFeedProps) => {
  const [productFeedData, setProductFeedData] = useState([]);
  const routeParams = useParams();
  const defaultLocale = getDefaultLocale();

  // console.log("ProductFeed props ---- ", defaultLocale);

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        rating_value: props?.rating_value || 1,
        breathtakingitem: props?.breathtakingitem || false,
        isNew: props?.isNew || false,
        isTopSeller: props?.isTopSeller || false,
        isLastChance: props?.isLastChance || false,
        newLowerPrice: props?.newLowerPrice || false,
        isLimitEdition: props?.isLimitEdition || false,
        timeRestrictedOffer: props?.timeRestrictedOffer || false,
        numberOfItem: props?.numberOfItem || 10,
        businessUnitCode: props?.businessUnitCode || "SHC059",
        primaryLang: props?.marketLocale || defaultLocale || "en",
        locale: routeParams.locale as string || "en",
        not_special: props?.enablePaxItems || false,
      };
      const data: any = await API.getProductFeedData(params);
      if (data?.res) {
        setProductFeedData(data.res?.data || []);
      } else {
        console.error("Failed to fetch:", data?.error);
      }
    };
    fetchData();
  }, [
    props?.marketLocale,
    defaultLocale,
    routeParams?.locale,
    props?.breathtakingitem,
    props?.businessUnitCode,
    props?.isLastChance,
    props?.isLimitEdition,
    props?.isNew,
    props?.isTopSeller,
    props?.newLowerPrice,
    props?.numberOfItem,
    props?.primaryLang,
    props?.timeRestrictedOffer,
    props?.rating_value,
    props?.enablePaxItems
  ]);

  const listToRender = productFeedData?.map((item: any, index: number) => {
    return (
      <div key={`productFeedItem--${index}`}>
        {/* <pre>{JSON.stringify(item, null, 2)}</pre> */}
        <ProductCard
          id={item?.id as string}
          key={`productFeedData--${index}`}
          no_of_columns={props?.no_of_columns}
          brand={item?.brand}
          title={item?.title}
          price={item?.price}
          subTitle={item?.title}
          image_link={item?.image_link}
          link={item?.link}
          maxCardWidth={`${props?.maxCardWidth}px`}
          businessUnitCode={props?.businessUnitCode}
          btn={{
            label: props?.btnLabel,
            target: "_blank"
          }}
        />
      </div>
    );
  })

  return (
    <Suspense fallback={<Spinner />}>
      {props?.displayView === "carousel" ? (
        <CarouselWrapper
          id={id || "productFeed"}
          transitionType={props?.carouseltransition}
          autoplay={props?.carouselAutoplay}
          slidesToShow={props?.slidesToShow}
          slidesToScroll={props?.slidesToScroll}
          autoplaySpeed={props?.autoplaySpeed}
          speed={props?.speed}
          centerMode={props?.centerMode}
          showPaging= {props?.showPaging}
          showButtons= {props?.showButtons}
          infinite= {props?.infinite}
          pauseOnHover= {props?.pauseOnHover}
          swipeToSlide= {props?.swipeToSlide}
          draggable= {props?.draggable} 
          variableWidth= {props?.variableWidth}
        >
          {listToRender}
        </CarouselWrapper>) 
        :
        <div
          id={id || "productFeed"}
          className={classNames(
            colVariant(props?.no_of_columns), 
            // "flex flex-wrap justify-between gap-5"
          )}
        >
          {listToRender}
        </div>
      }
    </Suspense>
  );
};

export default ProductFeed;
